import { useMutation } from '@tanstack/react-query';
import { useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type Params = {
  code: string;
  onSuccess?: () => void;
};

export function useReassignIssueOwnerRequest({ code, onSuccess }: Params) {
  const api = useApi();

  return useMutation<void, ExtendedAxiosError, void>({
    mutationKey: ['issues', code, 'reassign-request'],
    mutationFn: () =>
      api.issuesApi.reassignIssueRequest(code).then((r) => r.data),
    onSuccess,
  });
}
